const clientSelector = () => import("../components/clientSelector.vue");

export default [
  {
    name: "clientSelector",
    path: "/client-selector",
    meta: {
      Title: "clientSelector",
      layout: "LoggedLayout",
      requireAuth: true,
      requireAuceraUser: true
    },
    component: clientSelector,
  },
];